module.exports = __webpack_public_path__ + "img/img35.e536c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img35.jpg
// module id = 333
// module chunks = 0